import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api.js';

const DEFAULT_TEXT = `AVISO LEGAL

Última actualización: 21 de febrero de 2026

1. Naturaleza del sitio
La información publicada es de carácter técnico e informativo sobre la plataforma.

2. No asesoría profesional
El contenido no constituye asesoría legal, fiscal, financiera o contable.

3. Uso del sitio
Se prohíbe cualquier uso ilícito, intrusivo o que afecte la continuidad del servicio.

4. Propiedad intelectual
Marcas, código, documentación y diseño están protegidos por la legislación aplicable.

5. Ley y jurisdicción
Este aviso se rige por leyes mexicanas y jurisdicción competente en México.`;

export default function LegalNoticePage() {
  const [content, setContent] = useState(DEFAULT_TEXT);
  const [updatedAt, setUpdatedAt] = useState('21 de febrero de 2026');

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const data = await api.getPublicLegalContent();
        if (!mounted) return;
        setContent(data?.legalNotice || DEFAULT_TEXT);
        if (data?.updatedAt) {
          setUpdatedAt(new Date(data.updatedAt).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }));
        }
      } catch {
        if (mounted) setContent(DEFAULT_TEXT);
      }
    })();

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className="legal-page">
      <div className="legal-page__container">
        <div className="legal-page__top">
          <Link className="legal-page__back" to="/">← Volver al inicio</Link>
          <p className="legal-page__updated">Última actualización: {updatedAt}</p>
        </div>

        <h1>Aviso Legal</h1>
        <div className="legal-page__text">{content}</div>
      </div>
    </div>
  );
}
